module.exports = __webpack_public_path__ + "static/iphone8-crop-c37a529ef3db51a31ad959521ff4c94a.png";